// ----------------------------------------------------------------------

const ar = {
  en: `Arabic`,
  title: `العنوان`,
  hi: `أهلا`,
  email: `البريد الإلكتروني`,
  password: `كلمة المرور`,
  sign_in: `تسجيل الدخول`,
  username_is_required: ` مطلوب إدخال اسم المستخدم`,
  password_is_required: `مطلوب إدخال كلمة المرور `,
  show: `استعراض`,
  managment: `الإدارة`,
  username: `اسم المستخدم`,
  //nav specific
  educational_institutions: ` المؤسسات التعليمية`,
  about_educational_institution: `نظرة عامة`,
  educational_institution_classes: `صفوف وشعب المؤسسة التعليمية`,
  // educational_institution_divisions: `شعب المؤسسة التعليمية`,
  section_info: `معلومات الشعبة`,
  educational_institution_students: `طلاب المؤسسة التعليمية`,
  educational_institution_teachers: `معلمي المؤسسة التعليمية `,
  educational_institution_profile: `معلومات المؤسسة التعليمية  `,
  educational_institution_families: `أهالي المؤسسة التعليمية    `,
  programs: `برنامج الدوام`,
  //
  educational_institution: `المؤسسات التعليمية`,
  dashboard: `لوحة التحكم`,
  classes: `الصفوف`,
  divisions: `الشعب`,
  students: `الطلاب`,
  teachers: `المعلمون`,
  subjects: `المواد`,
  ads: `الإعلانات`,
  notes: `الملاحظات`,
  my_profile: `الملف الشخصي `,
  contact_us: `تواصل معنا`,
  export: `تصدير`,
  print: `طباعة`,
  confirm: `تأكيد`,
  division_info: `معلومات الشعبة`,
  //forms
  female: `أنثى`,
  male: `ذكر`,
  add_new_school: `إضافة مؤسسة تعليمية`,
  name_english: `الاسم بالانكليزي `,
  name_arabic: `الاسم بالعربي `,
  address: `العنوان`,
  city: `المدينة`,
  year_of_foundation: `سنة الإنشاء`,
  facebook_url: `رابط الفيسبوك `,
  logo: `اللوغو`,
  introduction: `مقدمة`,
  telephone2: `رقم الهاتف الارضي الثاني  `,
  mobile_phone2: `رقم  الموبايل الثاني `,
  select_type: `اختر نمط `,
  //tables
  name: `الاسم`,
  type: `النمط`,
  user_name: `اسم المستخدم`,
  manager_name: `اسم المدير`,
  telephone: `رقم الهاتف الأرضي`,
  mobile_phone: `رقم الموبايل`,
  action: `الحدث`,
  //subject
  add_new_subject: `إضافة مادّة جديدة `,
  add_subject: `إضافة مادّة  `,
  subject_id: `الرقم المميز المادّة  `,
  subject_name: `اسم المادّة `,
  add_subject_to_school: `إضافة مادّة للمؤسسة التعليميّة`,
  total_grade: `الدرجة العظمى`,
  add: `إضافة`,
  //families
  add_new_family: `إضافة عائلة جديدة`,
  family_id: `الرقم المميز للعائلة `,
  first_name: `الاسم الأول `,
  last_name: `الكنية `,
  //students
  add_new_student: `إضافة طالب جديد`,
  //class
  class_id: `رقم الصف  `,
  class_name: ` الصف `,
  division: `الشعبة`,
  //no data
  no_data: `لا يوجد بيانات`,
  //section
  add_section_to: "إضافة شعبة إلي",
  section_number: " رقم الشعبة",
  classification: "التصنيف",

  // add new student && family
  add_student_to_school: `اضافة طالب الى المدرسة`,
  add_family: `اضافة عائلة`,
  add_parent_to_school: `اضافة عائلة الى المدرسة`,
  phone_number: `رقم الهاتف`,
  first_name_is_required: `الاسم الاول مطلوب`,
  last_name_is_required: `الاسم الاخير مطلوب`,
  phone_is_required: `رقم الهاتف مطلوب`,
  address_is_required: `العنوان مطلوب`,
  send: `ارسال`,
  father_name: `اسم الاب`,
  father_name_is_required: `اسم الاب مطلوب`,
  mother_name: `اسم الام`,
  mother_name_is_required: `اسم الام مطلوب`,
  year_of_birth_is_required: `تاريخ الميلاد مطلوب`,
  date_of_birth: `تاريخ الميلاد`,
  father_phone_number: `رقم هاتف الاب`,
  student_phone_number: `رقم هاتف الطالب`,
  gender_is_required: `النوع مطلوب`,
  father_job: `مهنة الأب`,
  mother_job: `مهنة الام`,
  father_job_is_required: `مهنة الأب مطلوبة`,
  mother_job_is_required: `مهنة الام مطلوبة`,
  first_payment: `القسط الاول`,
  first_payment_is_required: `الدفعة الاولى مطلوبة`,
  parents: `الأهالي`,
  parent_id_is_required: `ادخال اسماء الاهالي مطلوب`,
  class_id_is_required: `الصف مطلوب`,
  section_id_is_required: `الشعبة مطلوبة`,
  image: `الصورة`,
  gender: `النوع`,
  section: `الشعبة`,
  points: `النقاط`,
  registration_status: `حالة التسجيل بالتطبيق`,
  unregistered: `غير مسجل بالتطبيق`,
  registered: `مسجل بالتطبيق`,

  // add teacher && ads
  add_teacher_to_school: `اضافة معلم الى المدرسة`,
  experiences: `الخبرات`,
  specialization: `الاختصاص`,
  title_is_required: `العنوان مطلوب`,
  add_ads: `اضافة اعلان`,
  Title: `العنوان`,
  phone_number_is_not_valid: `رقم الهاتف غير صالح!`,
  too_short: `قصير للغاية`,
  too_long: `طويل للغاية`,
  id: `الرقم المميز للاعلان`,
  created_at: `تاريخ الانشاء`,
  all_ads: `جميع الاعلانات`,
  add_new_ads: `اضافة اعلان جديد`,
  all_ads_for_school: `جميع اعلانات المدرسة`,
  add_new_teacher: `اضافة مدرس جديد`,
  teachers_of_school: `اساتذة المدرسة`,
  average_evaluation: `التقييم الوسطي`,
  year_of_birth: `تاريخ الميلاد`,
  are_you_sure_you_want_to_delete_this_teacher:
    " هل أنت متأكد من حذف هذا المعلم ؟",
  //grades && notes
  add_grade_for_student: `اضافة علامة للطالب`,
  material_is_required: `المادة مطلوبة`,
  materials: `المواد`,
  oral: `شفهي`,
  oral_is_required: `ادخال علامة الشفهي مطلوب`,
  written: `كتابي`,
  written_is_required: `ادخال علامة الكتابي مطلوب`,
  total: "المجموع",
  wazaef: `الوظائف`,
  test: `مذاكرة`,
  test_is_required: `علامة المذاكرة مطلوبة `,
  wazaef_is_required: `ادخال علامة الوظائف مطلوبة`,
  exam_is_required: `ادخال علامة الامتحان مطلوبة`,
  exam: `الامتحان`,
  add_grade: `اضافة علامة`,
  show_grads: `عرض العلامات`,
  max_grade: "اعلي درجة",
  add_notes: `اضافة ملاحظة`,
  grades_of_student: `علامات الطالب`,
  notes_of_student: `ملاحظات الطالب`,
  add_note_for_student: `اضافة ملاحظة للطالب`,
  add_new_class: `اضافة صف جديد`,
  add_image: `إضافة صورة`,
  show_secretaries: `حسابات الموظفات `,
  educational_institution_ads: `اعلانات المؤسسة التعليمية`,
  educational_institutions_secretaries: `حسابات موظفي المؤسسة التعليميّة`,
  add_new_secretary: `إضافة حساب موظف  `,
  manager_dashboard: `إدارة لوحة التحكم `,
  student_name: "اسم الطالب",
  note_id: "رقم الملاحظة",
  from: "من",
  Total: "الاجمالي",
  sending_notes_page: "صفحة الملاحظات المرسلة",
  // division-info
  Sunday: "الأحد",
  Monday: "الأثنين",
  Tuesday: "الثلاثاء",
  Wednesday: "الأربعاء",
  Thursday: "الخميس ",
  Saturday: "السبت",
  Friday: "الجمعة",
  week_days: "ايام الاسبوع",
  daily_classes_schedule_for: " جدول الحصص ليوم",
  class_number: "رقم الحصة",
  subject: "المادة المقررة",
  start_time: "وقت البداية",
  end_time: "وقت النهاية",
  class_1: "الحصة الأولي",
  class_2: "الحصة الثانية",
  class_3: "الحصة الثالثة",
  class_4: "الحصة الرابعة",
  class_5: "الحصة الخامسة",
  class_6: "الحصة السادسة",
  class_7: "الحصة السابعة",
  class_8: "الحصة الثامنة",
  class_9: "الحصة التاسعة",
  students_for_section: "طلاب هذة الشعبة",
  student_id: "رقم مميز للطالب",
  section_name: "اسم الشعبة",
  receiving_notes: `الملاحظات المستلمة`,
  add_time_slot: "إضافة حصة دراسية",
  add_time_slot_for: "أضف حصة دراسية ",
  select_day: "اختر اليوم ",
  select_subject: " اختر المادة الدراسية ",
  students_points: " نقاط الطلاب ",
  tests_grades_for_sections: "درجات الاختبارات لطلاب الشعبة",
  //  // Add New Student
  add_student: "إضافة طالب",
  add_student_to_school_for_family: "إضافة طالب للمدرسة لعائلة",
  // new eductional institution info page
  role: "صلاحية المستخدم",
  manager_account_info: "معلومات حساب المدير",
  new_educational_institution_info: "معلومات المؤسسة التعليمية الجديدة",
  manager_account: "حساب مدير المؤسسة",
  // add image to school page
  add_image_to_school_page: "صفحة إضافة صورة للمؤسسة التعليمية",
  add_image_to: "إضافة صورة لمؤسسة",
  school_image: " صورة المدرسة",
  // School Teachers Page
  total_teachers: "إجمالي المعلمين",
  // School Ads Page
  total_ads: "إجمالي الإعلانات",
  //
  //
  // complete translation for all
  login_page: `صفحة تسجيل الدخول`,
  add_section: `اضافة شعبة`,
  add_classes_to_school: `اضافة صفوف الى المدرسة`,
  deserved_amount: `المبلغ المستحق`,
  add_new_classes: `اضافة صفوف جديدة`,
  class_is_required: `مطلوب ادخال الصف`,
  deserved_amount_is_required: `مطلوب ادخال المبلغ المستحق`,
  add_subject_to_class_is_required: `اضافة مادة الى الصف مطلوب`,
  total_grade_is_required: `الدرجة العظمى مطلوبة`,
  add_subject_to_class: `اضافة مادة الى الصف `,
  add_subject_to: `اضافة مادة الى  `,
  add_section_to_class: `اضافة شعبة الى الصف`,
  number_is_required: `رقم الشعبة مطلوب`,
  classification_is_required: `التصنيف مطلوب`,
  select_classification: `اختر التصنيف`,
  enter_section_number: `ادخل رقم الشعبة`,
  days: `الايام`,
  name_en_is_required: `الاسم مطلوب`,
  add_time_slot_page: `اضافة برنامج`,
  material_id_is_required: `المادة مطلوبة`,
  format_must_be_hh_mm_ss: `يجب ان تكون الصيغة على شكل :ساعة دقيقة ثانية`,
  start_time_is_required: `تاريخ البدءمطلوب`,
  end_time_is_required: `تاريخ الانتهاء مطلوب`,
  edit_student: `تعديل معلومات الطالب`,
  sender: `المرسل`,
  text: `النص `,
  user_id: `الرقم المميز للمستخدم `,
  Arabic: `اللغة العربية`,
  date: `التاريخ`,
  specialization_is_required: `الاختصاص مطلوب`,
  reciving_notes: `الملاحظات المستلمة`,
  sending_notes: `الملاحظات المرسلة`,
  add_educational_institution_page: `اضافة مؤسسة تعليمية`,
  name_ar_is_required: `الاسم باللغة العربية مطلوب`,
  type_is_required: `النوع مطلوب`,
  email_is_required: `الايميل مطلوب`,
  city_is_required: `المدينة مطلوبة`,
  telephone_is_required: `الهاتف مطلوب`,
  mobile_phone_is_required: `رقم الموبايل مطلوب`,
  year_of_foundation_is_required: `سنة التأسيس مطلوبة `,
  manager_name_is_required: `اسم المدير مطلوب`,
  write_here: `اكتب هنا`,
  logo_is_required: `صورة الشعار مطلوبة`,
  image_is_required: `الصورة مطلوبة`,
  save: `حفظ`,
  all_subjects_page: `صفحة كل المواد`,
  all_educational_institution_page: `جميع المؤسسات التعليمية`,
  rows_per_page: `سطر في الصفحة`,
  edit: `تعديل `,
  delete: `حذف`,
  are_you_sure_you_want_to_delete_this_item: `هل انت متأكد من رغبتك بحذف هذا العنصر`,
  cancel: `اغلاق`,
  delete_item: `حذف عنصر`,
  search: `بحث`,
  are_you_sure_you_want_to_delete_this_familly: `هل انت متأكد من رغبتك بحذف هذه العائلة`,
  //
  name_is_required: `الاسم مطلوب`,
  log_out: `تسجيل الخروج`,
  tests_max_total: `المجموع الكلي للاختبارات`,
  // family Student page
  family_students: "طلاب العائلة",
  // edit teacher  page
  edit_teacher_information_page: "صفحة تعديل معلومات المعلم",
  edit_teacher_information: "تعديل معلومات المعلم",
  // All student management
  all_students: "كل الطلاب",
  edit_section: "تعديل الشعبة",
  save_edit: "حفظ التغييرات",
  // payment For Student page
  payment_info: "معلومات الدفع",
  add_payment: "إضافة قسط",
  payment_info_page: "صفحة معلومات الدفع",
  payment_number: "رقم القسط",
  amount: "المبلغ",
  date_of_pay: "تاريخ الدفع",
  remain_amount: "القسط المتبقي",
  // Add payment For Student page
  add_payment_for_student_page: "صفحة إضافة قسظ للطالب",
  amount_is_required: "مطلوب إدخال المبلغ",
  add_payment_for_student: "إضافة قسط لطالب",
  ministerial_decisions: `قرارات وزارية`,
  samples: `النماذج`,
  scientific: `علمي`,
  literary: `أدبي`,
  add_new_sample: `إضافة نموذج جديد`,
  material_id: `رقم المادة`,
  material_name: `اسم المادة`,
  question: `اكتب السؤال ..`,
  question_text: `نص السؤال`,
  answer1: `الإجابة الأولى`,
  answer2: `الإجابة الثانية`,
  answer3: `الإجابة الثالثة`,
  answer4: `الإجابة الرابعة`,
  question_id: `معرف السؤال`,
  sample_id: `معرف النموذج`,
  add_new_question: `إضافة سؤال جديد`,
  questions: `الأسئلة`,
  add_new_ministerial_decisions: `إضافة خبر وزاري`,
  time_of_sessions_required: `مدة الجلسة مطلوبة`,
  number_of_sessions_required: `عدد الجلسات مطلوب`,
  number_of_sessions: `عدد الجلسات`,
  price_of_sessions: `سعر الجلسة`,
  time_of_sessions: `وقت الجلسة`,
  sessions: `الجلسات`,
  add_new_session: `اضافة جلسة جديدة`,
  weekly_teacher_sessions: `جلسات الاستاذ الاسبوعية`,
  total_sessions: `الجلسات الكلية`,
  teacher_name: `اسم المعلم`,
  locked: "مقفول",
  unlocked: "عام",
  school_id: "معرف المدرسة",
  school_name: "اسم المدرسة",
  choose_season: `اختر الفصل`,
  first_season: `الفصل الاول`,
  second_season: `الفصل الثاني`,
  questions_count: `عدد الأسئلة`,
  show_results: `عرض النتائج`,
  result_of_student: `نتائج الطالب`,
  max_total: `الدرجة العظمى`,
  send_notification:`إرسال إشعار`,
  msg:`الرسالة`,
  notifications:`الإشعارات`,
   message_is_required:`الرسالة مطلوبة`,
   day_id:`اليوم`,

};

export default ar;
